import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const rejectInvitationStart = createAction(
  'REJECT_INVITATION::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
